module.exports = __webpack_public_path__ + "img/cbssport.83a42137.png";